import {HYDRATE} from 'next-redux-wrapper';
import {WALLET_CONSTANTS} from '../actions/WalletActions';

const WALLET_INITIATE_STATE = {
    udt: null,
    cryptoWallets: {},
    fiatBalance: {}
};

export default function Wallet(state = WALLET_INITIATE_STATE, action) {
    switch (action.type) {
        case HYDRATE:
            return {...state, ...action.payload.Wallet};

        case WALLET_CONSTANTS.SET_WALLETS_DATA:
            let payloadCryptoWallets = {...action.payload.cryptoWallets}

            try {
                Object.keys(payloadCryptoWallets).map(key => {
                    payloadCryptoWallets[key].value = 0
                })
            } catch (e) {
                // nothing
            }

            return {
                ...state,
                cryptoWallets:  payloadCryptoWallets,
                fiatBalance:  action.payload.fiatBalance,
                udt: new Date().getTime()
            };

        case WALLET_CONSTANTS.SET_BY_SYMBOL:
            return {
                ...state,
                cryptoWallets: {
                    ...state.cryptoWallets,
                    [action.payload.coin]: {
                        ...state.cryptoWallets[action.payload.coin],
                        balance: action.payload.balance
                    }
                }
            };

        case WALLET_CONSTANTS.SET_FIAT_BALANCE:
            return {
                ...state,
                fiatBalance: {
                    ...action.payload
                },
            };

        case WALLET_CONSTANTS.RESET:
            return {...WALLET_INITIATE_STATE};

        default:
            return state;
    }
}